import RegisterPhoneError from './RegisterPhoneError';
class CannotSendPhoneToken extends RegisterPhoneError {
    constructor(options) {
        super('Can not send phone token', options);
    }
}
export default CannotSendPhoneToken;
